import React, { FC, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
interface CompleteTripProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface CompleteTripFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CompleteTripFooter: FC<CompleteTripFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const CompleteTripModal: FC<CompleteTripProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);

  const confirmCompleteTrip = async () => {
    setLoading(true);
    try {
      await apiService.post('logistics/order/complete', {
        data: {
          order_id: order.id,
          amount_paid: order.calculated_order?.total_amount,
          bank_transfer: order.bank_transfer
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Updated successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Complete Trip'
      description={`Are you sure you want to mark this order #${
        order?.order_code?.toUpperCase() ?? ''
      } as complete?`}
      titleIcon={<TitleIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <CompleteTripFooter loading={loading} onCancel={onClose} onConfirm={confirmCompleteTrip} />
      }
    />
  );
};

export default CompleteTripModal;
